import { ActionType } from '../../core/redux/actionType';
import { ApiReducer, makeApiAction, makeApiReducer, makeRsaaTypes } from '../../core/api/rsaa';
import { addError, addLoading, noLoadingNoError, getLoading } from '../../core/api/module';
import * as R from 'ramda';
import { Endpoints } from '../../core/api/endpoints';
import { AppState } from '../../core/redux/appState';
import { ReportRecipientProject } from '../models';


const KEY_ACTION = ActionType.ReportRecipientProjectsRequest;
const ACTIONS    = [
  ActionType.ReportRecipientProjectsRequest,
  ActionType.ReportRecipientProjectsResponse,
  ActionType.ReportRecipientProjectsError,
];


type Payload = ReportRecipientProject[];


type Meta = {
  recipientId: number;
  dateRange?: number;
};


/**
 * Dispatch this to retrieve all the projects for which the recipient has access to reports
 *
 * @param recipientId - the user's database person Id
 * @param dateRange - can be undefined or the selected date range - defaults to 3 (last 3 months)
 */
export const reportRecipientProjectsAction = (
  recipientId: number,
  dateRange?: number,
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.ReportRecipientProjects,
    headers:  { 'content-type': 'application/json' },
    body:     JSON.stringify({
      recipientId: recipientId,
      dateRange: dateRange,
    }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { recipientId, dateRange }),
    bailout:  (state: AppState) => !!getLoading(state, KEY_ACTION, `${recipientId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const metaTag = `${action.meta.recipientId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  return R.assoc('reportRecipientProjects', payload, successState);
};

export const reportRecipientProjectsReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
